const TimeZoneOptions = () => {
  return (
    <>
      <option value='UTC'>UTC GMT+0:00</option>
      <option value='Africa/Cairo'>Africa/Cairo GMT+2:00</option>
      <option value='America/New_York'>America/New_York GMT-5:00</option>
      <option value='America/Chicago'>America/Chicago GMT-6:00</option>
      <option value='America/Denver'>America/Denver GMT-7:00</option>
      <option value='America/Los_Angeles'>America/Los_Angeles GMT-8:00</option>
      <option value='America/Sao_Paulo'>America/Sao_Paulo GMT-3:00</option>
      <option value='Australia/Sydney'>Australia/Sydney GMT+10:00</option>
      <option value='Asia/Almaty'>Asia/Almaty GMT+6:00</option>
      <option value='Asia/Baghdad'>Asia/Baghdad GMT+3:00</option>
      <option value='Asia/Bangkok'>Asia/Bangkok GMT+7:00</option>
      <option value='Asia/Dubai'>Asia/Dubai GMT+4:00</option>
      <option value='Asia/Hong_Kong'>Asia/Hong_Kong GMT+8:00</option>
      <option value='Asia/Tokyo'>Asia/Tokyo GMT+9:00</option>
      <option value='Asia/Seoul'>Asia/Seoul GMT+9:00</option>
      <option value='Asia/Singapore'>Asia/Singapore GMT+8:00</option>
      <option value='Asia/Kaliningrad'>Asia/Kaliningrad GMT+2:00</option>
      <option value='Asia/Yekaterinburg'>Asia/Yekaterinburg GMT+5:00</option>
      <option value='Asia/Omsk'>Asia/Omsk GMT+6:00</option>
      <option value='Asia/Novosibirsk'>Asia/Novosibirsk GMT+7:00</option>
      <option value='Asia/Krasnoyarsk'>Asia/Krasnoyarsk GMT+7:00</option>
      <option value='Asia/Irkutsk'>Asia/Irkutsk GMT+8:00</option>
      <option value='Asia/Yakutsk'>Asia/Yakutsk GMT+9:00</option>
      <option value='Asia/Vladivostok'>Asia/Vladivostok GMT+10:00</option>
      <option value='Asia/Sakhalin'>Asia/Sakhalin GMT+11:00</option>
      <option value='Asia/Kamchatka'>Asia/Kamchatka GMT+12:00</option>
      <option value='Asia/Magadan'>Asia/Magadan GMT+11:00</option>
      <option value='Europe/Amsterdam'>Europe/Amsterdam GMT+2:00</option>
      <option value='Europe/Berlin'>Europe/Berlin GMT+2:00</option>
      <option value='Europe/Helsinki'>Europe/Helsinki GMT+2:00</option>
      <option value='Europe/Istanbul'>Europe/Istanbul GMT+3:00</option>
      <option value='Europe/Kiev'>Europe/Kiev GMT+3:00</option>
      <option value='Europe/Lisbon'>Europe/Lisbon GMT+0:00</option>
      <option value='Europe/London'>Europe/London GMT+0:00</option>
      <option value='Europe/Madrid'>Europe/Madrid GMT+2:00</option>
      <option value='Europe/Moscow'>Europe/Moscow GMT+3:00</option>
      <option value='Europe/Minsk'>Europe/Minsk GMT+3:00</option>
      <option value='Europe/Samara'>Europe/Samara GMT+4:00</option>
      <option value='Europe/Paris'>Europe/Paris GMT+2:00</option>
      <option value='Europe/Riga'>Europe/Riga GMT+3:00</option>
      <option value='Europe/Saint_Petersburg'>Europe/Saint_Petersburg GMT+3:00</option>
      <option value='Europe/Sarajevo'>Europe/Sarajevo GMT+2:00</option>
      <option value='Europe/Sofia'>Europe/Sofia GMT+3:00</option>
      <option value='Europe/Vienna'>Europe/Vienna GMT+2:00</option>
      <option value='Pacific/Auckland'>Pacific/Auckland GMT+12:00</option>
      <option value='Pacific/Fiji'>Pacific/Fiji GMT+12:00</option>
      <option value='Pacific/Guam'>Pacific/Guam GMT+10:00</option>
    </>
  )
}

export {TimeZoneOptions}
